import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Image, NumberFormatter, Paper, Stack, Text, rem } from '@mantine/core';
export const CouponsTokenGift: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Paper px={{
    base: 10,
    sm: 79,
    lg: 34
  }} bd="2px dashed var(--text-prime)" pos="relative" pb={32}>
      <Image src="/assets/wallet/gifts.png" w={{
      base: 90,
      sm: 138,
      lg: 114
    }} h={{
      base: 90,
      sm: 126,
      lg: 114
    }} pos="absolute" top={{
      base: rem(-50),
      sm: rem(-70)
    }} left={0} right={0} mx="auto" alt="gift" />

      <Stack align="center" pt={{
      base: 50,
      sm: 60
    }}>
        <Text fz={12} c="var(--text-dark)" fw={700} tt="uppercase">
          {i18n._('Here are the details of your reward:')}
        </Text>

        <Image src="/assets/tokens/tether.svg" w={{
        base: 48,
        sm: 56
      }} h={{
        base: 48,
        sm: 56
      }} alt="tokens" />

        <Text c="var(--text-dark)" fz={{
        base: 14,
        sm: 21,
        lg: 18
      }} lh={{
        base: rem(16),
        sm: rem(20),
        lg: rem(18)
      }} ta="center" className={gunterzBold.className}>
          <Text span inherit c="var(--text-prime)">
            <NumberFormatter value={50} suffix=" USDT" />
          </Text>

          {i18n._(' have been added to your account!')}
        </Text>
      </Stack>
    </Paper>;
};